import axios from 'axios';
import { Auth } from 'aws-amplify';
import { EXPIRED } from '../auth/actions';

import Config from '../../config';

import { BP_ASSETS_CLIENTS_GET } from './actions';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';

export const api_create_client_asset = (data) => {

    return (dispatch, getState) => {

        Auth.currentSession().then((session) => {

        const token = session && session.idToken.jwtToken;

        var config = { headers: { Authorization: 'Bearer ' + token } };

        const dataNew = {
            ...data
        }

        delete dataNew['clientId'];


        return axios.post(`${Config.API_BASE_URL}/bp/client/asset-new/${data.clientId}`, dataNew, config)
            .then(response => {

                dispatch({
                    type: BP_ASSETS_CLIENTS_GET,
                    payload: {
                        clientAssets: response.data,
                        task: { result: true }
                    }
                })
            })
            .catch(error => {

                dispatch({
                    type: BP_ASSETS_CLIENTS_GET,
                    payload: {
                        errors: error.response.data,
                         task: { result: false }
                    }
                })

            });
}).catch(error => { 
//  dispatch({ type: EXPIRED }); 
 }); 
 };
}


export default api_create_client_asset;